export const constantDropdownReasonsOptions = [
    {name:'בקשת לקוח', value: 'Client Request'},
    {name:'בעיית ייצור', value: 'Production Problem'},
    {name:'בעיית תכנון', value: 'Planning Problem'}
]

export const PER_USER = '500'
export const NO_FINANCIALS = '100'
export const VIEW_ONLY = '200'
export const DEPARTMENT_ONLY = '400'
export const FULL_VIEW_ONLY = '900'
export const TASK_REMARK_ONLY = '901'
export const TASK_REMARK_QUANTITY_ONLY = '902'
export const ALL_FINANCIALS = '903'
export const FULL_SCREEN_ALLOWED = process.env.REACT_APP_FULL_SCREEN_ALLOWED !== 'false'